<div class="welcome-page-container">
	<span class="big"
		>{{ labels.lbl_boas_vindas }}{{ ProfileService.userData()?.firstName ? ', ' + ProfileService.userData()?.firstName : '' }}!</span
	>
	<cpi-msp-semantix-logo [darkMode]="darkMode"></cpi-msp-semantix-logo>
</div>
